import { IOptions } from "components/sideMenu/SideMenu";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "hooks/redux";

/***
Child suboptions can be passed to created futher settings options levels. Add subOptions to
the subOption of the parent as well as prop secondOptionHeader for styling purposes. 

label: string
url: string
subOptions?: Array< {
                    label: string;
                    url: string;
                    subOptions?: Array
                    secondOptionHeader?: boolean; }>
*/

export default function SettingOptionsTranslation() {
  const { t } = useTranslation();
  const { facilityStore } = useAppSelector(store => store);

  const options: IOptions[] = [
    {
      label: t("General"),
      url: "/admin/settings", //Temporary route
      subOptions: [
        {
          label: t("Language"),
          url: "/admin/settings/language",
        },
      ],
    },
    {
      label: t("Products"),
      url: "/admin/settings/products", //Temporary route
      subOptions: [
        {
          label: t("Folders"),
          url: "/admin/settings/folders",
        },
        {
          label: t("Discounts"),
          url: "/admin/settings/discount",
        },
        {
          label: t("Modifier Groups"),
          url: "/admin/settings/modifier_group",
        },
        {
          label: t("Departments"),
          url: "/admin/settings/departments",
        },
        {
          label: t("Forms"),
          url: "/admin/settings/forms",
        },
        {
          label: t("Vendors"),
          url: "/admin/settings/vendors",
        },
        {
          label: t("Types"),
          url: "/admin/settings/types",
        },
        {
          label: t("Groups"),
          url: "/admin/settings/groups",
        },
        {
          label: t("Units"),
          url: "/admin/settings/units",
        },
        {
          label: t("Inventory"),
          secondOptionHeader: true,
          url: "/admin/settings/inventory",
          subOptions: [
            {
              label: t("Receivings"),
              url: "/admin/settings/inventory",
            },
            {
              label: t("Transfers"),
              url: "/admin/settings/transfer",
            },
            {
              label: t("Counts"),
              url: "/admin/settings/counts",
            },
            {
              label: t("Labels"),
              url: "/admin/settings/labels",
            },
          ],
        },
      ],
    },
    {
      label: t("Facility"),
      url: "",
      subOptions: [
        {
          label: t("Details"),
          url: "/admin/settings/details",
        },
        {
          label: t("Settings"),
          url: "/admin/settings/facility-settings",
        },
        {
          label: t("Status Inputs"),
          url: "/admin/settings/status-inputs",
        },
        {
          label: t("Courses"),
          url: "/admin/settings/course",
        },
        {
          label: t("Divisions"),
          url: "/admin/settings/division",
        },
        {
          label: t("Tee Decks"),
          url: "/admin/settings/tee_deck",
        },
        {
          label: t("Staff Accounts"),
          url: "/admin/settings/staff",
        },
        {
          label: t("Printers"),
          url: "/admin/settings/printers",
        },

        {
          label: t("Email Templates"),
          url: "/admin/settings/email-template",
        },
        {
          label: t("PDFs"),
          url: "/admin/settings/pdf",
        },
      ],
    },

    {
      label: t("Customers"),
      url: "",
      subOptions: [
        {
          label: t("Tags"),
          url: "/admin/settings/customer_tags",
        },
        {
          label: t("Customer Types"),
          url: "/admin/settings/customer_types",
        },
      ],
    },

    {
      label: t("Registers"),
      url: "/admin/settings/register",
      subOptions: [
        {
          label: t("Registers"),
          url: "/admin/settings/registers",
        },
        {
          label: t("Register Group"),
          url: "/admin/settings/register-group",
        },
        {
          label: t("Cash Out"),
          url: "/admin/settings/cash-out",
        },

        {
          label: t("Shift Summary"),
          url: "/admin/settings/shifts",
        },
      ],
    },

    {
      label: t("Table Service"),
      url: "/admin/settings/table-service",
      subOptions: [
        // {
        //   label: t("Tables"),
        //   url: "/admin/settings/tables",
        // },
        {
          label: t("Floor Plan"),
          url: "/admin/settings/floor-plan",
        },
        {
          label: t("Kitchen Setup"),
          url: "/admin/settings/kitchen-location",
        },
        {
          label: t("Courses"),
          url: "/admin/settings/courses",
        },

        {
          label: t("Kitchen Display"),
          url: "/admin/kds", //Temporary route
        },
      ],
    },

    {
      label: t("Tee Sheets"),
      url: "/admin/settings/tee-sheet",
      subOptions: [
        {
          label: t("General"),
          url: "/admin/settings/tee-sheet/general",
        },
        {
          label: t("Booking Fees"),
          url: "/admin/settings/tee-sheet/booking-fees",
        },
        {
          label: t("Templates"),
          url: "/admin/settings/tee-sheet/template",
        },
        {
          label: t("Template Calendar"),
          url: "/admin/settings/tee-sheet/calendar",
        },
        {
          label: t("Open Windows"),
          url: "/admin/settings/tee-sheet/open-windows",
        },
        {
          label: t("Pricing Sheets"),
          url: "/admin/settings/tee-sheet/pricing-sheet",
        },
        {
          label: t("Check In Configuration"),
          url: "/admin/settings/tee-sheet/check-in-config",
        },
        {
          label: t("Shotgun Templates"),
          url: "/admin/settings/tee-sheet/shotgun-templates",
        },
        {
          label: t("Customer Type Configuration"),
          url: "/admin/settings/tee-sheet/customer-type-config",
        },
        {
          label: t("Notifications"),
          url: "/admin/settings/tee-sheet/notification",
        },
        {
          label: t("Cart Waiver"),
          url: "/admin/settings/cart-waiver",
        },
        {
          label: t("Cart Inventory"),
          url: "/admin/settings/cart-inventory",
        },
        {
          label: t("Booking Categories"),
          url: "/admin/settings/tee-sheet/booking-categories",
        },
        {
          label: t("Booking Restrictions"),
          url: "/admin/settings/tee-sheet/booking-restrictions",
        },
      ],
    },

    {
      label: t("Payments"),
      url: "",
      subOptions: [
        {
          label: t("General"),
          url: "/admin/settings/payments/general",
        },
        {
          label: t("Manage"),
          url: "/admin/settings/payments/manage",
        },
        {
          label: t("Card Readers"),
          url: "/admin/settings/card_reader",
        },
        {
          label: t("Payouts"),
          url: "/admin/settings/payouts",
        },
        {
          label: t("Bank Accounts"),
          url: "/admin/settings/bank_accounts",
        },
        {
          label: t("Payment Methods"),
          url: "/admin/settings/facility-payment-options",
        },
      ],
    },

    {
      label: t("Accounting"),
      url: "",
      subOptions: [
        {
          label: t("Taxes"),
          url: "/admin/settings/taxes",
        },

        {
          label: t("Accounting References"),
          url: "/admin/settings/accounting_references",
        },

        {
          label: t("Accounts"),
          url: "/admin/settings/accounts",
        },
        {
          label: t("Prize Accounts"),
          url: "/admin/settings/prizeAccounts",
        },
      ],
    },
    // {
    //   label: t("Dashboard"),
    //   url: "/admin/settings/dashboards",
    // },

    {
      label: t("Reservations"),
      url: "/admin/settings/reservations",

      subOptions: [
        {
          label: t("Modules"),
          url: "/admin/settings/reservations/modules",
        },
        {
          label: t("Templates"),
          url: "/admin/settings/reservations/templates",
        },
        {
          label: t("Notifications"),
          url: "/admin/settings/reservations/notifications",
        },
      ],
    },
    ...(facilityStore?.facility?.module_loyalty_points ? [
      {
        label: t("Loyalty Program"),
        url: "/admin/settings/loyalty-program",
      },
    ] : []),
  ];

  return options;
}
